import React, { FunctionComponent, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@mui/material';

import {
  getOneToOneTutorRates,
  resetOneToOneTutorRates,
} from '../../../../store/V2/OneToOneTutorRatesSlice';
import { resetGroupTutorRates } from '../../../../store/V2/GroupTutorRatesSlice';
import BasicLoader from '../../../../components/Loaders/BasicLoader';
import OneToOneRatesSection from './OneToOneRatesSection';
import { getGroupTutorRates } from '../../../../store/V2/GroupTutorRatesSlice/api';
import GroupRatesSection from './GroupRatesSection';

const UserRates: FunctionComponent = () => {
  const dispatch = useDispatch();

  // State
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    initPage();

    return () => {
      dispatch(resetOneToOneTutorRates());
      dispatch(resetGroupTutorRates());
    };
  }, []);

  const initPage = async () => {
    await dispatch(getOneToOneTutorRates());
    await dispatch(getGroupTutorRates());

    setInitialLoading(false);
  };

  if (initialLoading) {
    return (
      <Box sx={{ p: '30px' }}>
        <BasicLoader />
      </Box>
    );
  }

  return (
    <Box>
      <OneToOneRatesSection />

      <div style={{ minHeight: '30px' }} />

      <GroupRatesSection />
    </Box>
  );
};

export default UserRates;
